/**
 * botLaneBias — Soft-pull ARAM advance targets toward bridge X=0 (FID-BOT-05).
 */

export const ARAM_LANE_CENTER_X = 0;
export const ARAM_LANE_BIAS_STRENGTH = 0.35;

/**
 * @param {number} targetX
 * @param {number} [strength]
 */
export function biasAramLaneX(targetX, strength = ARAM_LANE_BIAS_STRENGTH) {
  if (!Number.isFinite(targetX)) return ARAM_LANE_CENTER_X;
  const s = Number.isFinite(strength) ? Math.min(1, Math.max(0, strength)) : ARAM_LANE_BIAS_STRENGTH;
  return targetX + (ARAM_LANE_CENTER_X - targetX) * s;
}
